<template>
	<section id="detail" :class="fake">
		<header>
			<h2>Projekce</h2>
		</header>
		<div class="content-wrapper">
			<span class="skeleton__copy" v-if="fake">
				<h3>👈 Vyberte film z programu.</h3>
			</span>
			<div class="detail__ticket">
				<div class="ticket__poster" :style="poster"></div>
				<div class="ticket__detail" :style="cinemaLogo">
					<h3><span class="cinema">{{ cinema.name }}:</span><span class="time">{{day}} {{time}}:</span> {{movie.title}}</h3>
					<p class="ticket__price" v-if="projection.price">{{ projection.price }} Kč</p>
				</div>
			</div>
			<ul class="sharing">
				<li><a :href="shareFacebookUrl" target="_blank" class="btn btn--blue" @click.prevent="shareFacebook"><span>Facebook</span> <i></i></a></li>
			</ul>
			<table>
				<tbody>
					<tr v-if="movie.title_orig">
						<th><span>Originální název</span></th>
						<td><span>{{movie.title_orig}}</span></td>
					</tr>
					<tr v-if="movie.director">
						<th><span>Režie</span></th>
						<td><span>{{movie.director}}</span></td>
					</tr>
					<tr v-if="projection.language">
						<th><span>Znění</span></th>
						<td><span>{{projection.language}}</span></td>
					</tr>
					<tr v-if="movie.year">
						<th><span>Rok</span></th>
						<td><span>{{movie.year}}</span></td>
					</tr>
					<tr v-if="movie.length">
						<th><span>Délka</span></th>
						<td><span>{{movie.length}} min</span></td>
					</tr>
					<tr v-if="projection.csfd_rating || projection.imdb_rating">
						<th><span>Hodnocení</span></th>
						<td><span>
							<span v-if="projection.csfd_rating">{{projection.csfd_rating}} (ČSFD)</span>
							<span v-if="projection.imdb_rating">{{projection.imdb_rating}} (IMDB)</span>
						</span></td>
					</tr>
					<tr>
						<th><span>Rezervace</span></th>
						<td><span><a :href="cinema.tel">{{cinema.phone}}</a>, <a :href="cinema.mailto">{{cinema.email}}</a></span></td>
					</tr>
					<tr v-if="projection.csfd_link">
						<th><span>Odkazy</span></th>
						<td><span><a :href="projection.csfd_link" target="_blank">csfd.cz</a></span></td>
					</tr>
				</tbody>
			</table>
			<div class="detail__trailer" v-if="movie.youtube">
				<a :href="youtube" target="_blank" class="btn btn--creme" @click.prevent="playTrailer"><span>&#9658; Trailer</span> <i></i></a>
			</div>

			<div class="detail__tickets" v-if="projection.tickets">
				<a :href="projection.tickets" target="_blank" class="btn btn--creme"><span>Koupit vstupenky</span> <i></i></a>
			</div>

			<p class="detail__plot"><span>{{movie.description}}</span></p>
			<aside class="detail__cinema">
				<img :src="cinema.map">
				<div class="contact">
					<h4><a :href="cinema.url" target="_blank">{{cinema.name}}</a></h4>
					<p>{{cinema.address}}<br>{{cinema.zip}}, {{cinema.city}}</p>
				</div>
			</aside>
		</div>
	</section>
</template>

<script>
import * as moment from 'moment'

export default {
	name: 'detail',
	methods: {
		playTrailer: function () {
			this.$store.commit('trailer', this.$store.state.projection.movie.youtube)
		},
		shareFacebook: function () {
			const popup = (url, title, w, h) => {
				var left = (screen.width / 2) - (w / 2)
				var top = (screen.height / 2) - (h / 2)
				return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)
			}
			popup(this.shareFacebookUrl, 'Facebook', 800, 600)
		}
	},
	computed: {
		projection: function () {
			return this.$store.state.projection
		},
		movie: function () {
			return this.$store.state.projection.movie
		},
		poster: function () {
			let image = false
			if (this.$store.state.projection.movie && this.$store.state.projection.movie.image) {
				if (this.$store.state.projection.movie.image.indexOf('http') !== -1) {
					image = btoa(unescape(encodeURIComponent(this.$store.state.projection.movie.image)))
				} else {
					image = this.$store.state.projection.movie.image
				}
			}
			return image
						? `background-image: url("https://www.artkina.cz/api/1.2/image/200/200/${image}/"); background-size: cover;` : ''
		},
		day: function () {
			return moment(this.$store.state.projection.date.date).format('DD.MM.')
		},
		time: function () {
			return moment(this.$store.state.projection.date.date).format('HH:mm')
		},
		youtube: function () {
			return `https://www.youtube.com/${this.$store.state.projection.movie.youtube}`
		},
		fake: function () {
			return (typeof this.$store.state.projection.fake !== 'undefined') ? 'is-skeleton' : ''
		},
		cinema: function () {
			const cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id)
			let mapsKey = 'AIzaSyBCJIbOMjUM-hXLJtET4qtHy3Oab9LJgog'
			let richCinema = {
				mailto: `mailto:${cinema.email}`,
				tel: `tel:${cinema.phone}`,
				map: `https://maps.googleapis.com/maps/api/staticmap?key=${mapsKey}&center=${cinema.gps}&zoom=16&size=240x150&scale=1&style=null&sensor=false&markers=icon:https://www.artkina.cz/www/images/cinemas/pin-${cinema.slug}.png|${cinema.gps}`
			}
			return Object.assign(cinema, richCinema)
		},
		cinemaLogo: function () {
			const cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id)
			return `background-image: url(https://www.artkina.cz/img/kino-${cinema.slug}.png);`
		},
		shareFacebookUrl: function () {
			const url = `https://moje.artkina.cz${this.$route.fullPath}`
			return `https://www.facebook.com/dialog/share?app_id=628733673908917&display=popup&href=${url}&redirect_uri=${url}`
		}
	}
}
</script>

<style lang=less>
	@import "../assets/less/default.less";

	section#detail { width: 45vw;
		header { border-bottom: none; }
	}
	.detail__ticket { position: relative; display: flex; min-height: 110px; margin-bottom: 0.5ex; color: @grey; -webkit-mask-box-image: url(../assets/images/sprites/stamp.svg) 5 repeat; mask-border: url("../assets/images/sprites/stamp.svg") 5 repeat; .bgc(#fff); width: 100%; .center(); z-index: 2;
		h3 { border-bottom: 1px dashed #5A5A5A; padding-bottom: .5ex; margin-bottom: 1em; width: 100%; font-size: 24/15rem;
			span.cinema { display: none; }
			span.time { display: block; color: @red; }
		}
	}
	.sharing { float: right; position: relative; top: -6px; margin-bottom: .5rem; padding-right: 1rem; z-index: 1;
		&:before { content: "Sdílej:"; .top-left(15px,-40px); font-size: 0.8rem; }
		.btn { display: inline-block; margin: 0; font-size: 1rem; }
	 }
	.ticket__poster { width: 30%; min-width: 40%; background: @redDark url('../assets/images/sprites/logo.png') 50% 50% no-repeat; }
	.ticket__price { font-family: "bebas-neue", sans-serif; font-size: 28/15rem; color: @red; }
	.ticket__detail { padding: 1ex 1em; flex-grow: 1; background-position: right 120%; background-repeat: no-repeat; background-size: 40%; }

	table { width: 100%; border-collapse: collapse; .center(); margin-bottom: 1em;
		th, td { text-align: left; padding: .5ex .1ex; border-top: 1px dashed #fff; border-bottom: 1px dashed #fff; }
		th { font-family: "bebas-neue", sans-serif; font-size: 18/15rem; letter-spacing: 2px; }
		td { line-height: 1.6;
			a { color: white; }
			a:hover { text-decoration: none; }
		}
	}

	.detail__trailer { text-align: center; margin: 1em 0;
		.btn { display: inline-block; margin: 1ex auto; font-size: 20/15rem; }
	}

	.detail__tickets { text-align: center; margin: 1em 0;
		.btn { display: inline-block; margin: 1ex auto; font-size: 20/15rem; }
	}

	.detail__plot { width: 100%; .center(); line-height: 1.4; text-align: justify; margin: 1em 0 2em; }

	.detail__cinema { display: flex; .bgc(#F7DFCE); color: @grey;
		.contact { padding: 1em 2em; flex-grow: 1;
			h4 { display: block; border-bottom: 1px dashed #5A5A5A; padding-bottom: 1em; margin-bottom: 1em;
				a { color: @red; font-size: 24/15rem; }
			}
		}
	}

	.is-skeleton {
		@radius: 5px;
		@opacity: .2;
		.content-wrapper {
			.skeleton__copy { opacity: 1; display: flex; .top-left(); .size(100%, 100%); font-family: "bebas-neue", sans-serif; font-size: 3rem; color: white;
				h3 { margin: auto; z-index: 100; }
			}
		}
		.detail__ticket { position: relative; mask-border: none; -webkit-mask-box-image: none; opacity: @opacity; border-radius: @radius; opacity: @opacity;
			&:before { .top-left(); display: inline-block; content: ""; width: 100%; height: 100%; background-color: darken(#DA3C3C, 20%); border-radius: @radius; }
			.ticket__poster { display: none; }
		}
		th, td { border-top: none; border-bottom: none; }
		th span, td span { position: relative; display: inline-block; opacity: @opacity;
			&:before { .top-left(); display: inline-block; content: ""; width: 100%; height: 100%; background-color: darken(#DA3C3C, 20%); border-radius: @radius; }
		}
		.sharing { display: none; }
		.detail__cinema { display: none; }
		.detail__plot { opacity: @opacity;
			span { font-size: 1.2em; line-height: 2.4rem; background-color: darken(#DA3C3C, 20%); color: darken(#DA3C3C, 20%);  border-radius: @radius; }
		}
	}

	@media @tablet {
		section#detail { width: 50vw; min-width: 0; }
	}

	@media @mobile {
		section#detail { width: 100vw; min-width: 0; border-color: @red; }
	}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue